$(function () {
    'use strict';

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": null,
        "hideDuration": null,
        "timeOut": "3000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    $.each($('div.alert-success[role=toastr]'), function() {
        var text = $(this).text();
        if (text != "") {
            toastr.success(text);
        }
    });

    $.each($('div.alert-warning[role=toastr]'), function() {
        var text = $(this).text();
        if (text != "") {
            toastr.warning(text);
        }
    });

    $.each($('div.alert-danger[role=toastr]'), function() {
        var text = $(this).text();
        if (text != "") {
            toastr.error(text);
        }
    });

    $.each($('.js-validation-error-explanation li'), function() {
        var text = $(this).text();
        if (text != "") {
            toastr.error(text);
        }
    });

});
